import {
  formatXmn,
  formatFiat,
  XMN_DECIMALS,
  FIAT_DECIMALS,
} from '../../../../formatting';

const MAX_INPUT_LENGTH = 18;

const toMaxPrecision = (amount) => {
  const [integer, decimal = ''] = parseFloat(amount)
    .toFixed(XMN_DECIMALS)
    .split('.');
  const truncated = decimal.slice(0, FIAT_DECIMALS).replace(/0+$/, '');
  return truncated ? `${integer}.${truncated}` : integer;
};

const sanitizeEuroInput = (value) => {
  const withoutSuffix = value.replace(/\s*EUR\s*/gi, '').trim();
  const commasNormalized = withoutSuffix.replace(/,/g, '.');
  const sanitized = commasNormalized.replace(/[^0-9.]/g, '');
  const parts = sanitized.split('.');
  const integerPart = (parts[0] || '').replace(/^0+(?=\d)/, '');
  const rebuilt =
    parts.length > 1
      ? `${integerPart}.${parts.slice(1).join('')}`
      : integerPart;
  const decimalParts = rebuilt.split('.');
  if (decimalParts[1]?.length > FIAT_DECIMALS) {
    return `${decimalParts[0]}.${decimalParts[1].slice(0, FIAT_DECIMALS)}`;
  }
  if (rebuilt.length > MAX_INPUT_LENGTH) {
    return rebuilt.slice(0, MAX_INPUT_LENGTH);
  }
  return rebuilt;
};

const euroToXmnAmount = (euroAmount, xmnRate) => {
  const numericEuro = parseFloat(euroAmount) || 0;
  const result = xmnRate > 0 ? numericEuro / xmnRate : 0;
  return result.toFixed(XMN_DECIMALS);
};

const truncateToXmnDecimals = (raw) => {
  const [integer, decimal = ''] = String(raw).split('.');
  return decimal.length > XMN_DECIMALS
    ? `${integer}.${decimal.slice(0, XMN_DECIMALS)}`
    : String(raw);
};

const formatEur = (amount) => formatFiat(amount, 'EUR');

export {
  formatXmn,
  formatEur,
  toMaxPrecision,
  sanitizeEuroInput,
  euroToXmnAmount,
  truncateToXmnDecimals,
};
